import React from 'react';
import {Upload, Form, Input, Select, Button} from 'antd';

const MediaModaContent = props => {
    const {handleSelect, handleCancel, handleSub, onFormVaulesChange, uploadProcess, showCreate, onUploadVideo, roomInfo, form} = props;

    const selectList = [
        {
            id: 1,
            name: '性别',
            maxSelect: 1,
            selectInfo: [
                {
                    value: '男',
                    label: '男'
                },
                {
                    value: '女',
                    label: '女'
                }
            ]
        },
        {
            id: 2,
            name: '年龄',
            maxSelect: 1,
            selectInfo: [
                {
                    value: '18-24岁',
                    label: '18-24岁'
                },
                {
                    value: '25-35岁',
                    label: '25-35岁'
                },
                {
                    value: '36-50岁',
                    label: '36-50岁'
                },
                {
                    value: '50岁以上',
                    label: '50岁以上'
                }
            ]
        },
        {
            id: 3,
            name: '行业',
            maxSelect: 1,
            selectInfo: [
                {
                    value: '综合',
                    label: '综合'
                },
                {
                    value: '数码家电',
                    label: '数码家电'
                },
                {
                    value: '食品酒水',
                    label: '食品酒水'
                },
                {
                    value: '美妆个护',
                    label: '美妆个护'
                },
                {
                    value: '服饰鞋包',
                    label: '服饰鞋包'
                },
                {
                    value: '滋补保健',
                    label: '滋补保健'
                },
                {
                    value: '大家居',
                    label: '大家居'
                }
            ]
        },
        {
            id: 4,
            name: '风格',
            maxSelect: 3,
            selectInfo: [
                {
                    value: '亲和力强',
                    label: '亲和力强'
                },
                {
                    value: '激情饱满',
                    label: '激情饱满'
                },
                {
                    value: '幽默有趣',
                    label: '幽默有趣'
                },
                {
                    value: '专业娴熟',
                    label: '专业娴熟'
                },
                {
                    value: '权威靠谱',
                    label: '权威靠谱'
                },
                {
                    value: '元气活力',
                    label: '元气活力'
                },
                {
                    value: '沉稳冷静',
                    label: '沉稳冷静'
                }
            ]
        }
    ];
    // 以下渲染相关
    const getUploadContent = () => {

        if (showCreate) {
            return (
                <div className="digital-aigc-image-upload">
                    <div className="digital-video-upload-default">
                        <div className="digital-aigc-image-upload-default-btn">替换当前资源</div>
                        <div className="digital-aigc-image-upload-default-desc">上传成功! </div>
                    </div>
                </div>
            );
        }

        if (uploadProcess) {
            return (
                <div className="digital-aigc-image-upload">
                    <div className="digital-aigc-image-upload-process-desc">上传中... {uploadProcess}%</div>
                    <div className="digital-aigc-image-upload-process">
                        <div
                            className="digital-aigc-image-upload-process-bar"
                            style={{width: `${uploadProcess}%`}}
                        />
                    </div>
                </div>
            );
        }

        if (!roomInfo.videoUrl) {
            return (
                <div className="digital-aigc-image-upload">
                    <div className="digital-video-upload-default">
                        <div className="digital-aigc-image-upload-default-btn">上传音频素材</div>
                        <div className="digital-aigc-image-upload-default-desc">可直接拖拽素材到此处上传</div>
                    </div>
                </div>
            );
        }

        return null;
    };

    return (
        <Form
            name="basic"
            validateTrigger={['onSubmit', 'onChange']}
            form={form}
            labelCol={{span: 5}}
            initialValues={roomInfo}
            preserve={false}
            onValuesChange={onFormVaulesChange}
        >
            <Form.Item
                className="digital-create-video"
                label="音频素材"
                colon={false}
                rules={[{required: true, message: '请上传音频素材'}]}
                name="videoUrl"
            >
                <Upload.Dragger
                    accept=".zip,.rar,.7z,.tar,.gz"
                    customRequest={onUploadVideo}
                    showUploadList={false}
                    className="stickers-part-content-upload"
                >
                    {getUploadContent()}
                </Upload.Dragger>
            </Form.Item>
            <Form.Item
                className="digital-faq-edit-modal-list-item-textarea"
                label="音库(主播)名称"
                colon={false}
                rules={[{required: true, message: '请输入音库(主播)名称'}]}
                name="anchorName"
            >
                <Input.TextArea
                    maxLength={150}
                    value={roomInfo.anchorName}
                    placeholder="请输入音库（主播）名称"
                    autoComplete="off"
                />
            </Form.Item>
            {
                selectList.map(item => {
                    if (item.maxSelect && item.maxSelect > 1) {
                        return (
                            <Form.Item
                                key={item.id}
                                className="digital-faq-edit-modal-list-item-textarea"
                                label={item.name}
                                colon={false}
                                rules={[{required: true, message: '请选择' + item.name}]}
                                name={item.id}
                            >
                                <Select
                                    mode="tags"
                                    showArrow
                                    onChange={(value) => {
                                        handleSelect(value, item.maxSelect);
                                    }}
                                    placeholder={'请选择' + item.name}
                                    value={roomInfo[item.id]}
                                    options={item.selectInfo}
                                />
                            </Form.Item>
                        );
                    }
                    return (
                        <Form.Item
                            key={item.id}
                            className="digital-faq-edit-modal-list-item-textarea"
                            label={item.name}
                            colon={false}
                            rules={[{required: true, message: '请选择' + item.name}]}
                            name={item.id}
                        >
                            <Select
                                placeholder={'请选择' + item.name}
                                value={roomInfo[item.id]}
                                options={item.selectInfo}
                            />
                        </Form.Item>
                    );
                })
            }
            <Form.Item>
                <div
                    className="digital-create-video-bth"
                >
                    <Button htmlType="button" onClick={handleCancel}>
                        取消
                    </Button>
                    <Button type="primary" htmlType="submit" style={{marginLeft: '30px'}} onClick={handleSub}>
                        提交
                    </Button>
                </div>
            </Form.Item>
        </Form>
    );
};

export default MediaModaContent;
